// External Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import transitions from 'material-ui/styles/transitions';

// Internal Dependencies

// Local Variables
const propTypes = {
  children: PropTypes.node,
  disableTransitions: PropTypes.bool,
  isAutoHeight: PropTypes.bool,
  maxWidth: PropTypes.number,
  styles: PropTypes.shape({
    paddingTop: PropTypes.number,
  }),
};

const defaultProps = {
  children: null,
  disableTransitions: false,
  isAutoHeight: false,
  maxWidth: 0,
  styles: {},
};

const rootStyles = {
  height: '100%',
  width: '100%',
};

const defaultInnerContainerStyles = {
  boxSizing: 'border-box',
  display: 'flex',
  flexFlow: 'column',
  // height: '100%',
  margin: '0 auto',
  maxWidth: 1440,
  padding: 32,
  transition: transitions.easeOut('450ms', 'all'),
  zIndex: 2,
};

// Component Definition
const MainScrollContainer = (props) => {
  const {
    children,
    disableTransitions,
    isAutoHeight,
    maxWidth,
    styles,
  } = props;

  const innerContainerStyles = isAutoHeight || maxWidth || disableTransitions
    ? {
      ...defaultInnerContainerStyles,
      height: isAutoHeight ? null : '100%',
      maxWidth,
      transition: disableTransitions ? 'none' : transitions.easeOut('450ms', 'all'),
    }
    : defaultInnerContainerStyles;

  const conversationStyles = { ...innerContainerStyles, ...styles };

  return (
    <div id="bundleScrollContainer" style={rootStyles}>
      <div id="conversationContainer" style={conversationStyles}>
        {children}
      </div>
    </div>
  );
};

MainScrollContainer.propTypes = propTypes;
MainScrollContainer.defaultProps = defaultProps;
export default MainScrollContainer;



/** WEBPACK FOOTER **
 ** ./src/shared/main-scroll-container/index.js
 **/